export default {
  'path': '/demo/form',
  'meta': {
    'name': 'demo-Form 组件合集',
    'title': 'Form 组件合集',
    'isComponentDoc': true,
    'category': 'Form'
  }
};
